// Lightweight API client for the Deo Réno backend (Spring Boot).
// In dev, requests are proxied to http://localhost:8080 (see "proxy" in package.json).
// In production, the React app and the API are served from the same origin (Nginx),
// so relative URLs work everywhere.

const TOKEN_KEY = "dr_admin_token";

function isExpired(token) {
    try {
        const payload = JSON.parse(
            atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
        );
        return payload.exp ? payload.exp * 1000 < Date.now() : false;
    } catch (e) {
        return true; // malformed token -> treat as invalid
    }
}

export const auth = {
    get: () => localStorage.getItem(TOKEN_KEY),
    set: (token) => localStorage.setItem(TOKEN_KEY, token),
    clear: () => localStorage.removeItem(TOKEN_KEY),
    isLoggedIn: () => {
        const token = localStorage.getItem(TOKEN_KEY);
        if (!token) return false;
        if (isExpired(token)) {
            localStorage.removeItem(TOKEN_KEY);
            return false;
        }
        return true;
    }
};

function authHeader() {
    const token = auth.get();
    return token ? { Authorization: `Bearer ${token}` } : {};
}

async function handle(res) {
    if (res.status === 401) {
        auth.clear();
    }
    if (!res.ok) {
        let message = `Erreur ${res.status}`;
        try {
            const body = await res.json();
            message = body.message || body.error || message;
        } catch (e) {
            /* ignore non-JSON error bodies */
        }
        const err = new Error(message);
        err.status = res.status;
        throw err;
    }
    if (res.status === 204) return null;
    return res.json();
}

export const api = {
    getProjects: () => fetch("/api/projects").then(handle),
    getFeatured: () => fetch("/api/projects/featured").then(handle),
    getCategories: () => fetch("/api/categories").then(handle),
    login: (username, password) =>
        fetch("/api/auth/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username, password })
        }).then(handle),
    createProject: (formData) =>
        fetch("/api/admin/projects", {
            method: "POST",
            headers: authHeader(),
            body: formData
        }).then(handle),
    setFeatured: (id, featured) =>
        fetch(`/api/admin/projects/${id}/featured`, {
            method: "PUT",
            headers: { "Content-Type": "application/json", ...authHeader() },
            body: JSON.stringify({ featured })
        }).then(handle),
    reorderProjects: (ids) =>
        fetch("/api/admin/projects/reorder", {
            method: "PUT",
            headers: { "Content-Type": "application/json", ...authHeader() },
            body: JSON.stringify({ ids })
        }).then(handle),
    deleteProject: (id) =>
        fetch(`/api/admin/projects/${id}`, {
            method: "DELETE",
            headers: authHeader()
        }).then(handle),
    createCategory: (name) =>
        fetch("/api/admin/categories", {
            method: "POST",
            headers: { "Content-Type": "application/json", ...authHeader() },
            body: JSON.stringify({ name })
        }).then(handle),
    renameCategory: (id, name) =>
        fetch(`/api/admin/categories/${id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json", ...authHeader() },
            body: JSON.stringify({ name })
        }).then(handle),
    reorderCategories: (ids) =>
        fetch("/api/admin/categories/reorder", {
            method: "PUT",
            headers: { "Content-Type": "application/json", ...authHeader() },
            body: JSON.stringify({ ids })
        }).then(handle),
    deleteCategory: (id) =>
        fetch(`/api/admin/categories/${id}`, {
            method: "DELETE",
            headers: authHeader()
        }).then(handle)
};
